import { AppButton, AppTextField } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useToaster from 'hooks/useToaster';
import { useState } from 'react';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import { useParams } from 'react-router-dom';
import useManageTopics from 'hooks/API/useManageTopics';

function AddTopicModal({ open, closeModal }) {
  const { classID, subjectID, chapterID } = useParams();
  const [topicName, setTopicName] = useState();
  const [formErrors, setFormErrors] = useState([]);

  const { mutate, isLoading, isError } = useManageTopics({ classID, subjectID, chapterID });
  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function handleSave() {
    setFormErrors([]);

    const data = {
      name: `${topicName}`.trim(),
    };

    const validation = manageTopicsSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    mutate(data);
    setTopicName('');
    closeModal();
  }

  const errors = checkForErrors(formErrors);

  return (
    <AppModal open={open} closeModal={closeModal} size="sm">
      <AppModalHeader>Create Topic</AppModalHeader>
      <AppModalBody>
        <div className="row">
          <div className="col-12">
            <AppTextField
              labelProps={{
                label: 'Topic name *',
                htmlFor: 'topicName',
              }}
              inputProps={{
                placeholder: 'Topic name *',
                id: 'topicName',
                name: 'topicName',
                value: topicName,
                onChange: (event) => setTopicName(event.target.value),
              }}
              fieldErrors={errors['name']}
            />
          </div>
        </div>
      </AppModalBody>
      <AppModalFooter>
        <div className="d-flex flex-row mt-4 justify-content-center">
          <AppButton
            variantClass="btn-primary mx-3"
            style={{ minWidth: '1.5rem' }}
            onClick={handleSave}
          >
            Save
          </AppButton>
          <AppButton variantClass="btn-plane p--tint mx-3" onClick={closeModal}>
            Cancel
          </AppButton>
        </div>
      </AppModalFooter>
    </AppModal>
  );
}

const manageTopicsSchema = Joi.object({
  name: Joi.string().required().trim(),
});

export default AddTopicModal;
